import React, { useEffect, useState } from "react";
import { connect, useSelector } from 'react-redux';
import { Table } from "components";
import { columnVisibilityItems } from "./columnVisibilityItems";
import { TableColumns } from "./TableColumns";
import { fetchPermission } from '../../../auth/permission/store/action';
import { ModuleProp } from '../../../auth/permission/store/actionType';
import ServerTable from "components/table/ServerTable";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const ModulesList: React.FC<Props> = ({ onGetModules, getModules }) => {
  const [limit, setLimit] = useState(4)
  const [offset, setOffset] = useState(0)
  const [hasNext, setHasNext] = useState(true);
  const [pageIndex, setPageIndex] = useState(0)
  const PermissionModule = useSelector((state: any) => state.permission?.fetchPermissionState);
  const modulesss = PermissionModule?.permission?.map((module: ModuleProp) => module);
  useEffect(() => {
    onGetModules(limit, offset);
  }, [onGetModules, limit, offset]);
  
const handlePaginationChange = (newLimit: number, newOffset: number) => {
    const newPageIndex = Math.floor(newOffset / newLimit);
    setLimit(newLimit);
    setOffset(newOffset);
    setPageIndex(newPageIndex);
    onGetModules(newLimit, newOffset);
  };
  return (
    <>
      <ServerTable
        headers={["System Setup", "System Models"]}
        data={modulesss}
        columnVisibilityItems={columnVisibilityItems}
        tableColumns={TableColumns}
        addButton={
          <></>
        }
        onPaginationChange={handlePaginationChange}
        pageIndex={pageIndex}
        pageSize={limit}
        hasNext={hasNext}
      />
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    getModules: state.permission?.fetchPermissionState,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  onGetModules: (limit: number, offset: number) => dispatch(fetchPermission(limit, offset)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModulesList);
